import { configureStore } from "@reduxjs/toolkit";
import allPropertiesReducer from "../redux/allPropertiesSlice";
import propertyIDandSNReducer from "../redux/propertyIDandSN";
import singlePropertyReducer from "../redux/singleProperty";
import searchQueryReducer from "../redux/searchQuery";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "singleProperty",
  version: 1,
  storage,
};
const persistSNconfig = {
  key: "propertyIDandSN",
  version: 1,
  storage,
};

const persistedSNandIDReducer = persistReducer(
  persistSNconfig,
  propertyIDandSNReducer
);
const persistedSinglePropertyReducer = persistReducer(
  persistConfig,
  singlePropertyReducer
);

export const store = configureStore({
  reducer: {
    allProperties: allPropertiesReducer,
    propertyIDandSN: persistedSNandIDReducer,
    singleProperty: persistedSinglePropertyReducer,
    searchQuery: searchQueryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore actions from redux-persist
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
